import React, {useEffect} from "react";
import { Navigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {clearMessage} from "../slices/message";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";

const Profile = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(clearMessage());
  }, [dispatch]);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Generate initials for the avatar
  const getInitials = (name) => {
    return name ? name.substring(0, 2).toUpperCase() : "US";
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="border-0 shadow-lg" style={{ borderRadius: '24px' }}>
            {/* Header / Banner Area */}
            <div 
              style={{ 
                height: '140px', 
                background: 'var(--primary-gradient)', 
                borderTopLeftRadius: '24px', 
                borderTopRightRadius: '24px' 
              }}
            ></div>
            
            <Card.Body className="text-center position-relative px-4 pb-5 pt-0">
              {/* Avatar overlapping the banner */}
              <div 
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center bg-white shadow-sm"
                style={{
                  width: '100px',
                  height: '100px',
                  marginTop: '-50px',
                  marginBottom: '20px',
                  border: '4px solid white',
                  fontSize: '2rem',
                  fontWeight: '700',
                  color: '#4f46e5'
                }}
              >
                {getInitials(currentUser.username)}
              </div>

              <h2 className="fw-bold mb-1" style={{ color: 'var(--text-main)' }}>
                {currentUser.username}
              </h2>
              <p className="mb-4" style={{ color: 'var(--text-muted)' }}>
                PartsKick Portal User
              </p>

              <div className="text-start bg-light rounded-4 p-4 mb-4">
                <h6 className="fw-bold mb-3 text-uppercase" style={{ fontSize: '0.85rem', letterSpacing: '0.5px', color: 'var(--text-muted)' }}>
                  Security & Access
                </h6>
                <div className="mb-3">
                  <span className="fw-bold me-2">Token ID:</span>
                  <code className="bg-white p-1 rounded text-muted border">
                    {currentUser.accessToken.substring(0, 12)}...{currentUser.accessToken.substr(currentUser.accessToken.length - 8)}
                  </code>
                </div>
                
                <div className="mt-4">
                  <span className="fw-bold d-block mb-2">Assigned Roles:</span>
                  <div className="d-flex flex-wrap gap-2">
                    {currentUser.roles && currentUser.roles.map((role, index) => (
                      <Badge 
                        bg="light" 
                        text="dark" 
                        className="border px-3 py-2 rounded-pill fw-medium" 
                        key={index}
                        style={{ color: 'var(--text-main)' }}
                      >
                        <i className="bi bi-shield-check me-1 text-success"></i>
                        {role.replace('ROLE_', '')}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>

              {currentUser.roles && currentUser.roles.find(r => r === "CHANGE_PASSWORD_PRIVILEGE") && (
                <Button 
                  href="/changePassword" 
                  className="btn-premium w-100 rounded-pill py-2"
                >
                  <i className="bi bi-key me-2"></i>
                  Change Password
                </Button>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
